const Pagination = ({ itemPerPage, totalItem, paginate, currentPage }) => {
  const pageNumber = [];
  for (let i = 1; i <= Math.ceil(totalItem / itemPerPage); i++) {
    pageNumber.push(i);
  }

  return (
    <nav>
      <ul className="pagination__container">
        {pageNumber.map((number) => (
          <li
            key={number}
            className={`pagination__item ${
              number === currentPage ? "active" : "inherit"
            } `}
            onClick={() => paginate(number)}
          >
            <div>{number}</div>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Pagination;
